import { render } from "./add_on.vue?vue&type=template&id=24a6ad41"
import script from "./add_on.vue?vue&type=script&lang=js"
export * from "./add_on.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__